import useBoolean from './useToggle';
export default useBoolean;